import type { SVGProps } from 'react';

const SvgTextItalic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M17 6h-6c-.55 0-1 .45-1 1s.45 1 1 1h2.04l-2.14 8H9.01c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-2.04l2.14-8H17c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgTextItalic;
